export const DATE = new Date().toISOString().slice(0, 10);
export const DefaultImageURL = 'https://res.cloudinary.com/synicsoftware/image/upload/v1634943577/blankhead_qw5qt6.png';
